import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { Document, Page, pdfjs } from "react-pdf";
import CheckPdf from '@/components/CheckPdf.js'

// import pdf from "@/common/img/anomalous/data.png";
// import pdf from "../../common/file.pdf"


export default function Inspector () {
  const navigate = useNavigate()

  useEffect(() => {

  }, []);// eslint-disable-line

  return (
    <div className="padd_24 flex-col hei100 tablebackcol" style={{ overflowY: 'auto', textAlign: 'center' }}>
      {/* <CheckPdf file={pdf}></CheckPdf> */}
    </div>
  )
}
